<template>
  <div>
    <el-drawer @close="handleClose" direction="btt" :destroy-on-close="true" size="90%" custom-class="fileDrawer" :visible.sync="drawer" :modal="false">
      <template v-if="fileList && fileList.length">
        <div class="list" v-if="!showView.show">
          <div class="item" @click="handleItem(item)" v-for="(item, index) in fileList" :key="`${index}a`">
            <img class="fileLogo" :src="item.fileLogo" alt="" />
            <p class="name">{{ item.name }}</p>
          </div>
        </div>
        <div v-else style="width: 100%; height: 100%">
          <div class="fileInfo">
            <div class="icon-back" @click="handleClose"><i class="el-icon-back"></i></div>
            <img class="fileLogo" :src="showView.item.fileLogo" alt="" />
            <h4>{{ showView.item.name }}</h4>
            <i @click="handleDown(showView.item)" class="el-icon-download"></i>
          </div>
          <iframe
            name="outerPage"
            :src="showView.url"
            frameborder="0"
            allowfullscreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            scrolling="res"
            id="bdIframe"
            ref="appIframe">
          </iframe>
        </div>
      </template>
      <template v-else>
        <div style="text-align: center">
          <img src="../assets/img/emptyData.png" alt="" />
        </div>
      </template>
    </el-drawer>
  </div>
</template>
<script>
import { Base64 } from 'js-base64';
export default {
  data() {
    return {
      drawer: false,
      fileList: [],
      showView: {
        url: '',
        item: {},
        show: false,
      },
    };
  },
  created() {},
  methods: {
    /**
     *
     * @param {[{name:'',url:''}]} file
     * 文件列表，必须为数组
     * 通过 ref 调用打开 抽屉 的方法
     *
     */
    openDrawer(file) {
      if (!Array.isArray(file)) {
        this.$message({ type: 'info', message: '暂无文件' });
        return;
      }
      this.drawer = true;
      this.handleFileType(file);
    },
    // 处理文件图标
    handleFileType(file) {
      const imgExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp'];
      const docExtensions = ['.docx', '.doc', '.pdf', '.txt'];
      const pptExtensions = ['.pptx', '.ppt'];
      const xlsExtensions = ['.xlsx', '.xls'];
      const videoExtensions = ['.mp4', '.mp3', '.avi'];
      file.forEach((e) => {
        const lowerCaseFileName = e.name.toLowerCase();
        const isImg = imgExtensions.some((ext) => lowerCaseFileName.endsWith(ext));
        const isDoc = docExtensions.some((ext) => lowerCaseFileName.endsWith(ext));
        const isPpt = pptExtensions.some((ext) => lowerCaseFileName.endsWith(ext));
        const isXls = xlsExtensions.some((ext) => lowerCaseFileName.endsWith(ext));
        const isVideo = videoExtensions.some((ext) => lowerCaseFileName.endsWith(ext));
        if (isImg) {
          this.$set(e, 'fileLogo', e.url);
        } else if (isDoc) {
          this.$set(e, 'fileLogo', require('../assets/img/fileView/文档.png'));
        } else if (isPpt) {
          this.$set(e, 'fileLogo', require('../assets/img/fileView/ppt.png'));
        } else if (isXls) {
          this.$set(e, 'fileLogo', require('../assets/img/fileView/表格.png'));
        } else if (isVideo) {
          this.$set(e, 'fileLogo', require('../assets/img/fileView/视频.png'));
        } else {
          this.$set(e, 'fileLogo', require('../assets/img/fileView/未知.png'));
        }
      });
      this.fileList = file;
      console.log('🚀 ~ file:', file);
    },
    handleItem(item) {
      console.log('🚀 ~ item:', item);
      this.showView.show = true;
      this.showView.item = item;
      this.showView.url = `${this.extractProtocolAndHostFromUrl(window.location.href)}/onlinePreview?url=${encodeURIComponent(Base64.encode(item.url))}`;
    },

    handleClose() {
      this.showView.show = false;
      this.showView.url = ``;
      this.showView.item = {};
    },
    handleDown(file) {
      this.common.downloadFile(file.url);
    },
    extractProtocolAndHostFromUrl(url) {
      const urlObject = new URL(url);
      const protocol = urlObject.protocol;
      let host = `${protocol}//www.qiis.cn:8013`;
      if (protocol == 'http:') {
        host = `${protocol}//10.50.200.26:8012`;
      }
      if (protocol == 'https:') {
        host = `${protocol}//www.qiis.cn:8013`;
      }
      return host;
    },
  },
};
</script>
<style scoped lang="less">
/deep/.fileDrawer {
  border-radius: 10px 10px 0 0;
  padding: 20px 25px;
  padding-top: 0;
  box-sizing: border-box;

  .el-drawer__header {
    margin-bottom: 0;
  }

  .list {
    display: flex;
    flex-wrap: wrap;

    .item {
      width: 160px;
      height: 150px;
      cursor: pointer;
      border-radius: 6px;
      border: 1px solid transparent;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      font-size: 14px;

      &:hover {
        border: 1px solid #D1D5DB;
        background: #F9FAFB;
      }

      .fileLogo {
        width: 50px;
        height: 50px;
      }

      .name {
        margin-top: 8px;
        text-align: center;
      }
    }
  }
}

.fileInfo {
  display: flex;
  margin-bottom: 20px;
  position: relative;
  align-items: center;

  .fileLogo {
    width: 20px;
    height: 20px;
    margin-right: 15px;
  }

  .icon-back {
    width: 30px;
    height: 30px;
    display: flex;
    margin-right: 15px;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &:hover {
      background-color: #D1D5DB;
    }

    .el-icon-back {
      font-size: 24px;
    }
  }


  .el-icon-download {
    font-size: 24px;
    font-weight: 600;
    cursor: pointer;
    margin-left: auto;
    margin-right: 50px;
    align-items: center;
  }
}

#bdIframe {
  width: 100%;
  height: calc(100% - 50px) // position: absolute;
    // top: 0;
    // right: 0;
    // z-index: 88;
}
</style>
